import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsInstance, IsNotEmpty, IsNumber, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
import { ReadOrderWeightDto } from './ReadOrderWeightDto';
import { ReadPosDto } from './ReadPosDto';
export class ReadOrderElementMetadataDto {
}
__decorate([
    ApiProperty({ type: () => Number, example: 10 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderElementMetadataDto.prototype, "maxQuantity", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 10 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderElementMetadataDto.prototype, "minQuantity", void 0);
__decorate([
    ApiProperty({ type: () => String, example: ['M3VFYR4BQ4UZPWVGIOZMG4D6'], isArray: true }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], ReadOrderElementMetadataDto.prototype, "categories", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 10 }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderElementMetadataDto.prototype, "printOrder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], ReadOrderElementMetadataDto.prototype, "containsAlcohol", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderElementMetadataDto.prototype, "notes", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadOrderWeightDto }),
    Type(() => ReadOrderWeightDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(ReadOrderWeightDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", ReadOrderWeightDto)
], ReadOrderElementMetadataDto.prototype, "weight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 10 }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderElementMetadataDto.prototype, "prepTime", void 0);
__decorate([
    ApiPropertyOptional({ type: ReadPosDto }),
    Type(() => ReadPosDto),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsUndefinable({ always: true }),
    IsInstance(ReadPosDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", ReadPosDto)
], ReadOrderElementMetadataDto.prototype, "pos", void 0);
//# sourceMappingURL=ReadOrderElementMetadataDto.js.map